import banner from "../Assets/Icons/banner.png";
import footerImage from "../Assets/Icons/bg-footer.png";
import AuthService from "../Service.js/authService";
import linkedIN from "../Assets/Icons/linked.svg";
import videoIcon from "../Assets/Icons/video.svg";
import xIcon from "../Assets/Icons/x.svg";
import faceBookIcon from "../Assets/Icons/faceebook.svg";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const FooterLayout = () => {
  const [logo, setLogo] = useState();
  const currentUser = localStorage.getItem("candidate");
  const getLogo = async () => {
    if (currentUser) {
      await AuthService.getCompanyLogoWithLogin()
        .then((oResponse) => {
          console.log("oResponse", oResponse.data.data);
          setLogo(oResponse.data.data);
          //setSingleSelectValue({...singleSelectValue, [id]:dropDownOPtions(oResponse.data.data.prescreen_fields)})
        })
        .catch((err) => err);
    } else {
      await AuthService.getCompanyLogoWithoutLogin()
        .then((oResponse) => {
          console.log("oResponse", oResponse?.data?.data);
          setLogo(oResponse.data.data);
          //setSingleSelectValue({...singleSelectValue, [id]:dropDownOPtions(oResponse.data.data.prescreen_fields)})
        })
        .catch((err) => err);
    }
  };
  useEffect(() => {
    getLogo();
  }, []);
  return (
    <div
      className="w-full flex justify-center items-center "
      style={{
        background: "linear-gradient(90deg, #FFF 0%, #F1F8FE 49.5%, #FFF 100%)",
        // backgroundSize: "cover",
        // backgroundRepeat: "repeat",
      }}
    >
      <div className="lg:w-3/4 w-full mb-10 lg:pl-20 ">
        <div class>
          <div className="flex justify-between ">
            <div className="mt-8 md:w-1/2 sm:w-1/2 xs:w-1/4">
              <img
                src={logo?.company_logo}
                alt="companylogo"
                className="w-14"
              />
            </div>

            <div className="mt-6 w-1/2">
              {/* <p className="text-[#848484] text-sm font-medium pt-4">
                Quick links
              </p> */}
              <p className="text-[#424444] text-sm font-medium pt-4">
                About Us
              </p>
              <p className="text-[#424444]  text-sm font-medium pt-4">
                Contact
              </p>
              <p className="text-[#424444]  text-sm font-medium pt-4">
                Privacy Policy
              </p>
              <p className="text-[#424444] text-sm font-medium pt-4">
                Terms & Conditions
              </p>
            </div>
            <div className="w-1/2 mt-10">
              <p className="text-[#848484] text-sm font-medium ">Get started</p>
              <div className=" mt-6">
                <Link className="text-base font-semibold text-[#0073E6] ">
                  Candidate login
                </Link>
              </div>
              <br />
              <div className="">
                <Link className="text-base font-semibold text-[#0073E6]">
                  Employer login{" "}
                </Link>
              </div>
            </div>

            <div className="w-1/2 mt-8">
              <p className="text-[#848484] text-sm font-medium pt-4">
                Follow us
              </p>
              <div className="flex flex-wrap mt-6">
                <img src={linkedIN} alt="linkedIN" className="" />
                <img src={xIcon} alt="xIcon" className="sm:px-4 xs:pl-2" />
                <img
                  src={videoIcon}
                  alt="videoIcon"
                  className="sm:px-4 xs:pl-2"
                />
                <img
                  src={faceBookIcon}
                  alt="faceBookIcon"
                  className="sm:px-4 "
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default FooterLayout;
